import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-348.44 -348.44 2488.89 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1024 161V351Q1024 365 1014.5 374.5Q1005 384 992 384H800Q787 384 777.5 374.5Q768 365 768 351V161Q768 147 777.5 137.5Q787 128 800 128H992Q1005 128 1014.5 137.5Q1024 147 1024 161ZM1022 535 1040 994Q1040 1006 1030 1013Q1017 1024 1006 1024H786Q775 1024 762 1013Q752 1006 752 992L769 535Q769 525 779.0 518.5Q789 512 803 512H988Q1002 512 1011.5 518.5Q1021 525 1022 535ZM1008 1469 1776 61Q1811 -2 1774 -65Q1757 -94 1727.5 -111.0Q1698 -128 1664 -128H128Q94 -128 64.5 -111.0Q35 -94 18 -65Q-19 -2 16 61L784 1469Q801 1500 831.0 1518.0Q861 1536 896.0 1536.0Q931 1536 961.0 1518.0Q991 1500 1008 1469Z"
	})
});
export default SvgWarning;
